/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { AppBar, Toolbar } from '@mui/material'
import Navigation from 'components/Navigation'
import { logout } from 'redux/auth/actions'
import jwtDecode from 'jwt-decode'

import Colors from 'utils/Colors'
import history from 'utils/history'
import { Scopes } from 'utils/authUtils'
import { getUserPermissionIcon } from 'utils/constants/user'
import { ExitToApp } from '@mui/icons-material'
import styles from './styles'
import MenuAvatar from "../../components/MenuAvatar"
import { ROUTE_CONSTANTS } from "../../utils/constants/routeConstants"

const SignedInLayout = ({ component: Component, ...rest }) => {
  const classes = styles()
  const dispatch = useDispatch()

  const token = useSelector((state) => state.auth.access_token)
  const decodedToken = jwtDecode(token)
  const userName = decodedToken.username

  const handleLogout = () => {
    dispatch(logout())
  }

  const handleRestrictions = () => {
    history.push(ROUTE_CONSTANTS.RESTRICTED_OPTIONS)
    history.go(0)
  }

  const handleUserManagement = () => {
    history.push(ROUTE_CONSTANTS.USER_MANAGEMENT)
    history.go(0)
  }

  const menuOptions = [{ action: handleLogout, text: 'Sair', icon: <ExitToApp /> }]

  if (decodedToken.scopes.includes(Scopes.OPTIONS_MANAGEMENT)) {
    menuOptions.unshift({
      action: handleRestrictions,
      icon: getUserPermissionIcon(Scopes.OPTIONS_MANAGEMENT),
      text: 'Opções Restritivas',
    })
  }

  if (decodedToken.scopes.includes(Scopes.USER_MANAGEMENT)) {
    menuOptions.unshift({
      action: handleUserManagement,
      icon: getUserPermissionIcon(Scopes.USER_MANAGEMENT),
      text: 'Gerenciamento de Usuários',
    })
  }

  const renderMainBar = () => (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: Colors.headerColor }}>
        <Toolbar>
          <div className={classes.titleContainer}>
            <img
              src="/assets/images/logos/client_logo.png"
              alt="Logo"
              className={classes.logo}
            />
            <img
              src="/assets/images/logos/toolbar_logo.svg"
              alt="Logo By Dimensa branco"
              className={classes.logoDimensa}
            />
            <h2>KYE</h2>
            <Navigation />
          </div>

          {process.env.REACT_APP_LOGIN_DISABLED === 'true' ? null : (
            <div className={classes.userContainer}>
              <MenuAvatar username={userName} options={menuOptions} />
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <div>
          {renderMainBar()}
          <Component {...matchProps} />
        </div>
      )}
    />
  )
}

export default SignedInLayout
